import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.5 1.33981L0 6.92805V20H2V8.07194L9.5 3.66018L16.2299 7.61895L17.244 5.89508L9.5 1.33981Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 23V11.4172L13.4994 17.1689L23 11.4222V23H4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 8.99999V9.08474L13.5 14.8311L4 9.07921V8.99999H23Z"}}]};

const MarkAsUnreadFilled = Vue.extend<IconProps>({
  name: 'MarkAsUnreadFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'mark-as-unread-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MarkAsUnreadFilled;
